import { Box, Typography } from '@mui/material';
import { FormInputLabelProps } from './FormInput.types';
import UITooltip from '../../ui/UITooltip';

export default function FormInputLabel({
  label,
  inputId,
  required,
  tooltipProps,
  typographyVariant = 'body1',
}: FormInputLabelProps) {
  return (
    <Box mb={tooltipProps ? 0 : 0.5} display="flex" alignItems="center">
      <Typography
        component="label"
        htmlFor={inputId}
        variant={typographyVariant}
        fontWeight="fontWeightMedium"
      >
        {`${label}${required ? '*' : ''}`}
      </Typography>
      {tooltipProps ? <UITooltip {...tooltipProps} /> : null}
    </Box>
  );
}
